"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCUR = void 0;
var TYPE_CURSOR = 2;

function isCUR(buffer) {
  if (buffer.readUInt16LE(0) !== 0) {
    return false;
  }

  var type = buffer.readUInt16LE(2);
  return type === TYPE_CURSOR;
}

exports.isCUR = isCUR;